import script from "./TicketForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketForm.vue?vue&type=script&setup=true&lang=js"

import "./TicketForm.vue?vue&type=style&index=0&id=00df746c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00df746c"]])

export default __exports__